var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,16h2v7l-1,1H3L2,23V16H4v6H14ZM23,0H11L10,1V6h2V2H22V20H18v2h5l1-1V1ZM8,16v2h2V16ZM20,4H18V6h2ZM14,4V6h2V4Zm4,6h2V8H18Zm0,8h2V16H18ZM8.4,7.2l-8,6,1.2,1.6L9,9.25l7.4,5.55,1.2-1.6-8-6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjects);
export default __webpack_public_path__ + "static/1787897133/media/icon-projects.b259dddd92a6a3a5848625ee38d48eb3.svg";
export { ForwardRef as ReactComponent };